import React from "react"
import { Container } from "./styles";

interface Props {
    onClick: () => void;
}

const PrimaryButton: React.FC<Props> = ({onClick, children}) => {
    return <Container onClick={onClick}>
        {children}
    </Container>
}

export default PrimaryButton;